import { createReducer, on } from '@ngrx/store';
import { BookableProductActions } from 'src/app/core/state/app.actions';
import { STATE_STATUS } from 'src/app/shared/models';
import { BookableProductState } from './bookable-product.state';

export const TAG = 'bookableProducts';

export interface FiltersType {
	structureUUID?: string;
	featureValue?: string[];
	communityUUID?: string;
	active?: boolean;
	updateDate?: string;
	communityEntityUUID?: string;
	[key: string]: unknown;
}

const initialState: BookableProductState = {
	filters: {
		featureValue: [],
		active: true,
	},
	sort: undefined,
	pages: [0],
	data: { totalBookableProductsCount: 0, bookableProducts: [] },
	features: [],
	structures: [],
	status: STATE_STATUS.UNKNOWN,
	gridSearch: null,
	deleteStatus: 'unknown',
  cachedPages: []
};

export const counterReducer = createReducer(
	initialState,
	/**
	 * Parte standard di un reducer
	 */
	on(BookableProductActions.setSort, (state: BookableProductState, { sort }) => ({
		...state,
		sort,
	})),
	on(BookableProductActions.setPages, (state: BookableProductState, { pages }) => ({
		...state,
		pages,
	})),
	on(BookableProductActions.setBookableProductsSuccess, (state: BookableProductState, { data }) => {
		return {
			...state,
			status: STATE_STATUS.READY,
			data: {
				bookableProducts: data.bookableProducts,
				totalBookableProductsCount: data.totalBookableProductsCount,
			},
			pages: data.pages,
		};
	}),
	on(BookableProductActions.setBookableProductsError, (state: BookableProductState) => ({
		...state,
		status: STATE_STATUS.ERROR,
	})),
	on(BookableProductActions.setStatus, (state: BookableProductState, { status }) => {
		return {
			...state,
			status,
		};
	}),
	on(BookableProductActions.setGridSearch, (state: BookableProductState, { search }) => {
		return {
			...state,
			gridSearch: search,
		};
	}),
	on(BookableProductActions.setDeleteBookableProducts, (state: BookableProductState) => {
		return {
			...state,
			deleteStatus: STATE_STATUS.LOADING,
		};
	}),
	on(BookableProductActions.setDeleteBookableProductsSuccess, (state: BookableProductState) => {
		return {
			...state,
			deleteStatus: STATE_STATUS.READY,
		};
	}),
	on(BookableProductActions.setDeleteBookableProductsError, (state: BookableProductState) => {
		return {
			...state,
			deleteStatus: STATE_STATUS.ERROR,
		};
	}),
	/**
	 * PARTE SPECIFICA DEL REDUCER
	 */
	on(BookableProductActions.setFilters, (state: BookableProductState, { filters }) => ({
		...state,
		filters: {
			...filters,
			structureUUID: filters.structureUUID !== 'allStructures' ? filters.structureUUID : undefined,
			communityUUID: filters.communityEntityUUID,
		},
	})),
	on(BookableProductActions.setStructures, (state: BookableProductState, { structures }) => ({
		...state,
		structures,
	})),
	on(BookableProductActions.setFeatures, (state: BookableProductState, { features }) => ({
		...state,
		features,
	})),
	on(BookableProductActions.updateFilters, (state: BookableProductState, { updatedFilters }) => ({
		...state,
		filters: {
			...state.filters,
			...updatedFilters,
		},
	})),
	on(BookableProductActions.addFeatureValueToFilters, (state: BookableProductState, { featureValueUUID }) => ({
		...state,
		filters: {
			...state.filters,
			featureValue: state.filters.featureValue?.concat(featureValueUUID),
		},
	})),
	on(BookableProductActions.removeFeatureValueFromFilters, (state: BookableProductState, { featureValueUUID }) => ({
		...state,
		filters: {
			...state.filters,
			featureValue: state.filters.featureValue?.filter((uuid) => uuid !== featureValueUUID),
		},
	})),
  on(BookableProductActions.setCachedPages, (state: BookableProductState, { pages }) => ({
		...state,
		cachedPages: [...new Set([...state.cachedPages, ...pages])],
	})),
	on(BookableProductActions.resetCache, (state: BookableProductState) => ({
		...state,
		cachedPages: [],
    status: STATE_STATUS.READY,
		pages: [0],
		data: { totalBookableProductsCount: 0, bookableProducts: [] },
	}))
);
